/*
 * ファイルアップロード（api create）
 */
import { apiCreate, apiDirectUploadCreate } from '@/actions/ApiBaseActions';
export const API_CREATE_FILE_UPLOAD = 'API_CREATE_FILE_UPLOAD';
export const API_CREATE_FILE_UPLOAD_SUCCESS = 'API_CREATE_FILE_UPLOAD_SUCCESS';
export const API_CREATE_RESOURCE_UPLOAD = 'API_CREATE_RESOURCE_UPLOAD';
export const API_CREATE_RESOURCE_UPLOAD_TO_STORAGE = 'API_CREATE_RESOURCE_UPLOAD_TO_STORAGE';
export const API_CREATE_RESOURCE_UPLOAD_DONE = 'API_CREATE_RESOURCE_UPLOAD_DONE';
/**
 * ファイルアップロード
 * @param data
 * @param meta
 * @returns
 */
export const apiCreateFileUpload = ({ json }, meta) => apiCreate(API_CREATE_FILE_UPLOAD, '/file/upload', json, Object.assign({ headers: { 'Content-Type': 'multipart/form-data' } }, meta));
/**
 * sandboxへのファイルのアップロード用URLの取得
 * @param json
 * @param meta
 */
export const apiCreateResourceUpload = ({ json }, meta) => apiCreate(API_CREATE_RESOURCE_UPLOAD, '/resource', json, Object.assign(Object.assign({}, meta), { isSnakeCase: true }));
export const apiCreateResourceUploadToStorage = (value, meta) => apiDirectUploadCreate(API_CREATE_RESOURCE_UPLOAD_TO_STORAGE, value.url, value.file, Object.assign(Object.assign({}, meta), { headers: { 'Content-Type': value.contentType }, isObjectUpload: true }));
/**
 * sandboxへのファイルのアップロード完了
 * @param path
 * @param meta
 */
export const apiCreateResourceUploadDone = ({ path }, meta) => apiCreate(API_CREATE_RESOURCE_UPLOAD_DONE, `/resource/${path.id}/upload_done`, {}, Object.assign(Object.assign({}, meta), { isSnakeCase: true }));
